import { http } from '../../config/axios'

 const findMotorCredito = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/motorcredito/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findMotorCredito', error)
      throw Error(error.response.data)
    })
}

export default findMotorCredito;
